import { createReducer, on } from '@ngrx/store';
import * as suretyActions from './surety-validator.actions';
import { initialSuretyValidatorState } from './surety-validator.state';

export const suretyValidatorReducer = createReducer(
  initialSuretyValidatorState,
  on(suretyActions.SetSelectedBranch, (state, { branch }) => ({
    ...state,
    selectedBranch: branch,
  })),
  on(suretyActions.ValidateSuretySuccess, (state, { payload }) => ({
    ...state,
    bondResult: payload,
    error: null,
  })),
  on(suretyActions.ValidateSuretyError, (state, { payload }) => ({
    ...state,
    bondResult: null,
    error: payload,
  }))
);
